module.exports = __webpack_public_path__ + "img/jcb.cb7fe70c.svg";